"use client"
import { useState } from 'react'
import type { Locale } from '@/lib/i18n'
import type { Post } from '@/lib/api'
import PostCard from '@/components/PostCard'
import LoadMoreButton from '@/components/Pagination/LoadMoreButton'

export default function ClientLoadMore({ locale }: { locale: Locale }) {
  const [posts, setPosts] = useState<Post[]>([])
  const [loadedIds, setLoadedIds] = useState<Set<number>>(new Set())
  
  const handleLoadMore = (newPosts: Post[]) => {
    // Filtrer les doublons pour éviter les clés dupliquées
    const uniquePosts = newPosts.filter(post => !loadedIds.has(post.id))
    
    if (uniquePosts.length > 0) {
      setPosts((prev) => [...prev, ...uniquePosts])
      setLoadedIds(prev => new Set([...prev, ...uniquePosts.map(p => p.id)]))
    }
  }
  
  return (
    <div>
      <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
        {posts.map((p) => (
          <PostCard key={`loadmore-${p.id}`} post={p} />
        ))}
      </div>
      <LoadMoreButton
        locale={locale}
        initialOffset={10}
        onLoaded={handleLoadMore}
      />
    </div>
  )
}

